import { useTranslation } from "react-i18next";
import {
    HeaderWrapper,
    HeaderRow,
    HeaderLeft,
} from "./DashboardHeader.StyledComponents";
import { CompanySelector } from "@/app/shared/components/CompanySelector";
import { useDebtorAccount } from "@/app/shared/utils/hooks/useDebtorAccount";


export const DashboardHeader = () => {
  const { t } = useTranslation("invoicesDashboard");
  const { isInternal, selectedDebtor } = useDebtorAccount();
  const showDebtorPrompt = isInternal && !selectedDebtor;

  return (
    <div>
        <HeaderWrapper>
          <HeaderRow>
            <HeaderLeft>
              {showDebtorPrompt
                ? t("header.selectDebtor")
                : t("header.title")
              }
            </HeaderLeft>
            <CompanySelector />
          </HeaderRow>
        </HeaderWrapper>
    </div>
  );
};